// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Address, Hash, isAddressEqual as isAddressEqualOriginal } from "viem";
import { TokenList } from "../store/global/getAllTokenLists";
import * as Sentry from "@sentry/browser";

export const getTokenDecimals = (tokenAddress: Hash, tokenList: TokenList | undefined): number => {
  if (tokenList) {
    const decimals = tokenList[tokenAddress]?.chainInfo.decimals;
    if (decimals) {
      return decimals;
    }
  }
  const message = `Could not get decimals for ${tokenAddress}. Falling back to config`;
  console.warn(message);
  Sentry.captureMessage(message);
  const hardcodedDecimals = 18;
  if (hardcodedDecimals === undefined) {
    const warning = `Could not get hardcoded decimals for ${tokenAddress}. Falling back to 18`;
    Sentry.captureMessage(warning);
    const FALLBACK_DECIMALS = 18;
    return FALLBACK_DECIMALS;
  }
  return hardcodedDecimals;
};
export const getTokenDecimalsByAddress = (
  tokenAddress: Address,
  tokenList: TokenList | undefined
): number => {
  if (tokenAddress) {
    const tokenDecimals = getTokenDecimals(tokenAddress, tokenList);
    return tokenDecimals;
  } else {
    const message = `No token address passed in - returning hardcoded decimals / 18`;
    console.warn(message);
    Sentry.captureMessage(message);
    const FALLBACK_DECIMALS = 18;
    return FALLBACK_DECIMALS;
  }
};

export const getTokenTicker = (tokenAddress: Hash, tokenList: TokenList | undefined): string => {
  if (tokenList) {
    const ticker = tokenList[tokenAddress]?.ticker;
    if (ticker) {
      return ticker;
    }
  }
  const message = `Could not get display name for ${tokenAddress}. Falling back to tokenAddress`;
  console.warn(message);
  Sentry.captureMessage(message);
  return tokenAddress;
};
export const getTokenName = (tokenAddress: Hash, tokenList: TokenList | undefined): string => {
  if (tokenList) {
    const displayName = tokenList[tokenAddress]?.name;
    if (displayName) {
      return displayName;
    }
  }
  const message = `Could not get display name for ${tokenAddress}. Falling back to tokenAddress`;
  console.warn(message);
  Sentry.captureMessage(message);
  return tokenAddress;
};

// viem throws on undefined addresses when using isAddressEqual
// We want to handle undefined addresses though.
export const isAddressEqual = (a: Address | undefined, b: Address | undefined): boolean => {
  if (!a || !b) {
    Sentry.captureMessage(`An address is undefined A Address: ${a}, B Address: ${b}`);
    return false;
  }
  return isAddressEqualOriginal(a, b);
};
